import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CONTACT } from "@/data/site";

export const Layout = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 80);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return (
    <div className="min-h-screen bg-sand">
      <Header />
      <main data-testid="main-content"><Outlet /></main>
      <Footer />
      <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="floating-whatsapp-button" aria-label="WhatsApp"
        className="btn-wa fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full shadow-xl transition-transform hover:scale-105">
        <MessageCircle className="h-6 w-6" />
      </a>
    </div>
  );
};
